import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  instanceHeader: {
    fontSize: "1.125rem",
    fontWeight: "700",
    marginRight: "8px",
    marginBottom: "24px",
  },
}))

export default styles
